import React from 'react'
import { motion } from 'framer-motion'
import { Mail, Phone, MapPin } from 'lucide-react'
import Logo from '../ui/Logo'

const Footer = ({ variant = 'full' }) => {
  const contactInfo = {
    email: 'crowblockofficial@gmail.com',
    phone: '+2349133697360',
    address: '3, Phase 1, Eliminigwe Estate Elelenwo Road, Port Harcourt, Rivers State, Nigeria'
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  }

  if (variant === 'minimal') {
    return (
      <footer className="bg-neutral-900 text-white py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-neutral-400">© 2025 CROWBLOCK. All rights reserved.</p>
        </div>
      </footer>
    )
  }

  return (
    <footer className="bg-neutral-900 text-white py-16 border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-center"
        >
          <motion.div variants={itemVariants}>
            <Logo variant="full" size="large" theme="light" alt="Crowblock" className="mb-4" />
            <p className="text-lg text-neutral-400 mb-8 max-w-md mx-auto">
              Empowering communities through transparent crypto crowdfunding
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-8">
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-8">
              <div className="flex items-center space-x-2 text-neutral-400 hover:text-white transition-colors cursor-pointer">
                <Mail className="h-5 w-5" />
                <span>{contactInfo.email}</span>
              </div>
              <div className="flex items-center space-x-2 text-neutral-400 hover:text-white transition-colors cursor-pointer">
                <Phone className="h-5 w-5" />
                <span>{contactInfo.phone}</span>
              </div>
              <div className="flex items-start space-x-2 text-neutral-400 hover:text-white transition-colors cursor-pointer max-w-xs">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-left leading-tight">{contactInfo.address}</span>
              </div>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="mb-6">
            <nav className="flex justify-center space-x-6 text-neutral-400">
              <a href="/terms" className="hover:text-white transition-colors">Terms of Service</a>
              <span>|</span>
              <a href="/privacy" className="hover:text-white transition-colors">Privacy Policy</a>
            </nav>
          </motion.div>

          <motion.div variants={itemVariants} className="text-sm text-neutral-500">
            © 2025 CROWBLOCK. All rights reserved.
          </motion.div>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer